<div 
  class="datlaz-toast" 
  [class]="'datlaz-toast--' + getTypeClass()"
  [class.datlaz-toast--visible]="isVisible"
  (click)="onToastClick()"
>
  <div class="datlaz-toast__icon">
    <i [class]="getIconClass()"></i>
  </div>
  
  <div class="datlaz-toast__content">
    <h4 class="datlaz-toast__title">{{ toast.title }}</h4>
    <p class="datlaz-toast__message">{{ toast.content }}</p>
  </div>
  
  <button 
    class="datlaz-toast__close" 
    (click)="onCloseClick($event)"
    aria-label="Close notification"
  >
    <i class="fas fa-times"></i>
  </button>
  
  <div class="datlaz-toast__progress" *ngIf="toast.duration">
    <div class="datlaz-toast__progress-bar"></div>
  </div>
</div>